import { authFetch } from "../../utils/authFetch";

const apiURL = require('./apiURL');
const fetch = authFetch;
// const apiURL = `http://localhost:3000`;

// types of action
const Types = {
  STRIPE_LIST: "PAYMENT_STRIPE_LIST",
  STRIPE_INTENT: "PAYMENT_STRIPE_INTENT",
  STRIPE_PAYMENT_METHODS: "PAYMENT_STRIPE_PAYMENT_METHODS",
  STRIPE_CREATE_CUSTOMER: "PAYMENT_STRIPE_CREATE_CUSTOMER",
  PAYMENT_GET_STATS: "PAYMENT_GET_STATS",
  PAYMENT_GET_BUNDLES: "PAYMENT_GET_BUNDLES",
  PAYMENT_MODAL: "PAYMENT_MODAL",
  PAYMENT_SELECT_BUNDLE: "PAYMENT_SELECT_BUNDLE",
  STRIPE_CREATE_CHARGE: "PAYMENT_STRIPE_CREATE_CHARGE",
  STRIPE_PROCESSING_CHARGE: "PAYMENT_STRIPE_PROCESSING_CHARGE",
  PAYMENT_STRIPE_ADD_NEW_CARD: "PAYMENT_STRIPE_ADD_NEW_CARD",
  PAYMENT_STRIPE_SAVING_CARD: "PAYMENT_STRIPE_SAVING_CARD",
  PURCHASED_SERVICES: "PURCHASED_SERVICES",
  PURCHASE_CONFIRMATION_MODAL_OPEN: "PURCHASE_CONFIRMATION_MODAL_OPEN",
  PURCHASE_SERVICE: "PURCHASE_SERVICE",
  PURCHASED_COURSES: "PURCHASED_COURSES",
};

const addNewCard = status => ({
  type: Types.PAYMENT_STRIPE_ADD_NEW_CARD,
  status
});

const savingNewCard = status => ({
  type: Types.PAYMENT_STRIPE_SAVING_CARD,
  status
});


const selectBundle = bundle => ({
  type: Types.PAYMENT_SELECT_BUNDLE,
  bundle
});

const showPricingModal = status => ({
  type: Types.PAYMENT_MODAL,
  status
});

const paymentBundles = response => ({
  type: Types.PAYMENT_GET_BUNDLES,
  payload: response
});

const getBundles = () => {

  return (dispatch,getState) => {

    fetch(apiURL + `/payment/bundles` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(paymentBundles(data))
    })
    .catch(e => console.log(e))

  }
};

const paymentStats = response => ({
  type: Types.PAYMENT_GET_STATS,
  payload: response
});

const getPaymentStats = () => {

  return (dispatch,getState) => {

    fetch(apiURL + `/payment/stats` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(paymentStats(data))
    })

  }
};


const stripeIntent = response => ({
  type: Types.STRIPE_INTENT,
  payload: response
});

const getStripeIntent = (advisor) => {

  return (dispatch,getState) => {

    const state = getState()

      let qs = {}

      if (advisor){
        qs.advisor = 1
      }

    const stripeCustomerID = state.payment.stats && state.payment.stats.stripeCustomerID

      if (stripeCustomerID){
          qs.customerID = stripeCustomerID
      }



      fetch(apiURL + `/payment/stripe/intent?` + (new URLSearchParams(qs).toString())  , {
          credentials: 'include',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {
        dispatch(stripeIntent(data))
      })

  }
};

const purchasedService = response => ({
  type: Types.PURCHASE_SERVICE,
  payload: response
});

const purchaseService = (serviceId,orgId) => {

  return (dispatch,getState) => {

    const state = getState()

    // /payment/services/purchase
    // /payment/services/purchased
    fetch(apiURL + `/payment/services/purchase` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({serviceId,orgId}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(purchasedService(data))
    })

  }
};

const setPurchaseConfirmationModalOpen = (modalOpen, selectedServiceId) => ({
  type: Types.PURCHASE_CONFIRMATION_MODAL_OPEN,
  selectedServiceId,
  modalOpen
})

const purchasedServices = response => ({
  type: Types.PURCHASED_SERVICES,
  payload: response
});

const getPurchasedServices = () => {

  return (dispatch,getState) => {

    const state = getState()

    // services are per org - only courses are per user. On website we only need courses at the moment
    fetch(apiURL + `/payment/courses/purchased` , {
    // fetch(apiURL + `/payment/services/purchased` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(purchasedServices(data))
    })

  }
};

const purchasedCourses = response => ({
  type: Types.PURCHASED_COURSES,
  payload: response
});

const getPurchasedCourses = () => {

  return (dispatch,getState) => {

    const state = getState()

    // /payment/services/purchase
    // /payment/services/purchased
    fetch(apiURL + `/payment/courses/purchased` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(purchasedCourses(data))
    })

  }
};

const getStripePublicIntent = ({
    amount,
    currency
                               }) => {

  return (dispatch,getState) => {

    const state = getState()

    const queryParams = `?amount=${amount}&currency=${currency}`

    // fetch(apiURL + `/payment/stripe/publicIntent` , {
    fetch(apiURL + `/payment/stripe/paymentIntent${queryParams}` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(stripeIntent(data))
    })

  }
};

const stripePaymentMethods = response => ({
  type: Types.STRIPE_PAYMENT_METHODS,
  payload: response
});

const getStripePaymentMethods = () => {

  return (dispatch,getState) => {

    const state = getState()

    const stripeCustomerID = state.payment.stats && state.payment.stats.stripeCustomerID

    if (stripeCustomerID){

      fetch(apiURL + `/payment/stripe/paymentMethods?customerID=${stripeCustomerID}` , {
          credentials: 'include',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {
        dispatch(stripePaymentMethods(data))
      })

    } else {
      // dispatch(createStripeCustomer())
    }
  }
};

const stripeCreateCustomer = response => ({
  type: Types.STRIPE_CREATE_CUSTOMER,
  payload: response
});

const createStripeCustomer = () => {
  console.log('inside createStripeCustomer')

  return (dispatch,getState) => {

    const state = getState()

    const stripeCustomerID = state.payment.stats && state.payment.stats.stripeCustomerID

    const businessDetails = state.payment.stats && state.payment.stats.businessDetails
    const name = businessDetails && businessDetails.name || businessDetails && businessDetails.companyName
    const email = businessDetails && businessDetails.email

    if (!stripeCustomerID){
      fetch(apiURL + `/payment/stripe/createCustomer` , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({
            name,
            email
          }),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {
        dispatch(stripeCreateCustomer(data))
        dispatch(getStripePaymentMethods())
      })
    }
  }
};

const stripeProcessingCharge = () => ({
  type: Types.STRIPE_PROCESSING_CHARGE,
});

const stripeCharge = response => ({
  type: Types.STRIPE_CREATE_CHARGE,
  payload: response
});

const createStripeCharge = (paymentMethodID) => {
  console.log('inside createStripeCharge')

  return (dispatch,getState) => {

    dispatch(stripeProcessingCharge())

    const state = getState()

    // const stripeCustomerID = state.payment.stats && state.payment.stats.stripeCustomerID
    const bundleID = state.payment.selectedBundle.id


    // if (stripeCustomerID){
      fetch(apiURL + `/payment/stripe/charge` , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({
            paymentMethodID,
            bundleID,
              bundle: state.payment.selectedBundle,
            isNew: true,
            organisationName: state.createAccount.organisation
          }),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {
        dispatch(stripeCharge(data))

        if (data && data.paymentIntent && data.paymentIntent.status == "succeeded"){

          window.gtag('event', 'conversion', {
              'send_to': 'AW-776797276/kUZ1CNXl0rgBENz4s_IC',
              'value': data.paymentIntent.amount,
              'currency': 'EUR',
              'transaction_id': data.paymentIntent.id,
              // 'event_callback': callback
          });

          dispatch(getPaymentStats())
        }
      })
    // }
  }
};

const attachPaymentMethod = (paymentMethodID) => {
  console.log('inside createStripeCharge')

  return (dispatch,getState) => {

    dispatch(stripeProcessingCharge())

    const state = getState()

    // const stripeCustomerID = state.payment.stats && state.payment.stats.stripeCustomerID
    // const bundleID = state.payment.selectedBundle.id


    // if (stripeCustomerID){
      fetch(apiURL + `/payment/stripe/attach` , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({
            paymentMethodID,
            // bundleID,
            //   bundle: state.payment.selectedBundle,
            // isNew: true,
            // organisationName: state.createAccount.organisation
          }),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {
        dispatch(stripeCharge(data))
      })
    // }
  }
};

const processStripeCharge = ({paymentIntentID, bundle, customerDetails}) => {
  console.log('inside createStripeCustomer')

  return (dispatch,getState) => {

    dispatch(stripeProcessingCharge())

    const state = getState()

    fetch(apiURL + `/payment/stripe/process` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
          paymentIntentID,
          bundle,
          customerDetails,
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
        data.bundle = bundle
      dispatch(stripeCharge(data))

      if (data.paymentIntent.status == "succeeded"){

        window.gtag('event', 'conversion', {
            'send_to': 'AW-776797276/kUZ1CNXl0rgBENz4s_IC',
            'value': data.paymentIntent.amount,
            'currency': 'EUR',
            'transaction_id': data.paymentIntent.id,
            // 'event_callback': callback
        });

        dispatch(getPaymentStats())
      }
    })
  }
};


const Actions = {
  getPaymentStats,
  getBundles,
  createStripeCustomer,
  attachPaymentMethod,
  getStripeIntent,
  getStripePublicIntent,
  getStripePaymentMethods,
  showPricingModal,
  selectBundle,
  createStripeCharge,
  addNewCard,
  savingNewCard,
  processStripeCharge,
  purchaseService,
  getPurchasedServices,
  setPurchaseConfirmationModalOpen
};


export {Types, Actions}
